import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useGetUser } from '../../queries/users';
import { ProfileSettings } from './ProfileSettings';
import { headerTabsOptions } from './headerTabsOptions';
import { AppBar, Toolbar } from 'components/common';
import { HeaderMenu } from './HeaderMenu';
import { PageURL } from 'router/pageURL';
import logo from 'images/StrideUp_Logo_RGB_Neg.png';
import { PermissionType } from 'enums/permissionType.enum';
import { IHeaderMenuItem } from './types';
import { useAuth } from 'providers';

const filterHeaderTabsToRender = (userAccessGroups: PermissionType[]) => {
  return headerTabsOptions.filter(({ permissions }) =>
    permissions?.some((permission: PermissionType) => userAccessGroups.includes(permission)),
  );
};

export const AppHeader = () => {
  const { isSignedIn } = useAuth();
  const { data: user } = useGetUser();

  const userAccessGroups: PermissionType[] = user?.roles.map(r => r.role.type) ?? [];

  const isProfileSettingsDisplayed = isSignedIn;

  const headerTabsToRender = filterHeaderTabsToRender(userAccessGroups);

  return (
    <AppHeaderBody isProfileSettingsDisplayed={isProfileSettingsDisplayed} headerTabsToRender={headerTabsToRender} />
  );
};

type AppHeaderBodyProps = {
  headerTabsToRender: IHeaderMenuItem[];
  isProfileSettingsDisplayed?: boolean;
};

const AppHeaderBody = ({ headerTabsToRender, isProfileSettingsDisplayed }: AppHeaderBodyProps) => {
  return (
    <AppBar>
      <Toolbar sx={{ pr: '24px' }}>
        <Link to={PageURL.ROOT} className={'text-white no-underline'}>
          <img src={logo} alt='Strideup logo' className={'w-16'} />
        </Link>
        <div className={'flex w-full items-center px-1 pl-6'}>
          {headerTabsToRender.map(({ textId, menuOptions, link = '' }) => {
            const contentToRender = menuOptions ? (
              <HeaderMenu textId={textId} menuOptions={menuOptions} />
            ) : (
              <Link to={link} className={'block py-1.5 px-2 text-sm uppercase text-white no-underline'}>
                <FormattedMessage id={textId} />
              </Link>
            );

            return (
              <div key={textId} className={'my-0'}>
                {contentToRender}
              </div>
            );
          })}
        </div>
        {isProfileSettingsDisplayed && <ProfileSettings />}
      </Toolbar>
    </AppBar>
  );
};
